import { Component, Input } from '@angular/core';

import { NoticiasService } from '../noticias.service';

@Component({
  selector: 'noticias-lista',
  templateUrl: './noticias-lista.component.html',
  styleUrls: ['./noticias-lista.component.scss'],
})
export class NoticiasListaComponent {

  @Input() noticias = [];

  constructor(private servico: NoticiasService) { }

  getMedia(noticia) {
    return this.servico.getMedia(noticia);
  }
}
